import { contrastText } from './colors';
import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: 'Inter',
  htmlFontSize: 15,
  fontSize: 15,
  h1: { // app/xxl/regular
    fontFamily: 'Inter',
    fontSize: '42px',
    letterSpacing: '0px',
    lineHeight: '48px',
    color: contrastText,
    textTransform: 'none',
    fontWeight: 400,
  },
  h2: { // app/xxl/bold
    fontFamily: 'Inter',
    fontSize: '42px',
    letterSpacing: '0px',
    lineHeight: '48px',
    color: contrastText,
    textTransform: 'none',
    fontWeight: 600,
  },
  h3: { // app/xl/regular
    fontFamily: 'Inter',
    fontSize: '30px',
    letterSpacing: '0px',
    lineHeight: '36px',
    color: contrastText,
    textTransform: 'none',
    fontWeight: 400,
  },
  h4: { // app/xl/bold
    fontFamily: 'Inter',
    fontSize: '30px',
    letterSpacing: '0px',
    lineHeight: '36px',
    color: contrastText,
    textTransform: 'none',
    fontWeight: 600,
  },
  h5: { // app/l/regular
    fontFamily: 'Inter',
    fontSize: '24px',
    letterSpacing: '0px',
    lineHeight: '30px',
    color: contrastText,
    fontWeight: 400,
  },
  h6: { // app/l/bold
    fontFamily: 'Inter',
    fontSize: '24px',
    letterSpacing: '0px',
    lineHeight: '30px',
    color: contrastText,
    fontWeight: 600,
    textTransform: 'none',
  },
  subtitle1: { // app/m/regular
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '18px',
    letterSpacing: '0px',
    lineHeight: '24px',
    textTransform: 'none',
    fontWeight: 400,
  },
  subtitle2: { // app/m/bold
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '18px',
    letterSpacing: '0px',
    lineHeight: '24px',
    textTransform: 'none',
    fontWeight: 600,
  },
  body1: { // app/s/regular
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '16px',
    letterSpacing: '0px',
    textTransform: 'none',
    lineHeight: '20px',
    fontWeight: 400,
  },
  body2: { // app/s/bold
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '16px',
    letterSpacing: '0px',
    textTransform: 'none',
    lineHeight: '20px',
    fontWeight: 600,
  },
  caption: { // app/xs/regular
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '13px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textTransform: 'none',
    fontWeight: 400,
  },
  overline: { // app/xs/bold
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '13px',
    letterSpacing: '0px',
    lineHeight: '20px',
    textTransform: 'none',
    fontWeight: 700,
  },
  button: { // app/button/medium
    fontFamily: 'Inter',
    color: contrastText,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textTransform: 'none',
    fontWeight: 400,
  },
};
